import { render } from "./Publicidad.vue?vue&type=template&id=2fd0a3e6&scoped=true"
import script from "./Publicidad.vue?vue&type=script&lang=js"
export * from "./Publicidad.vue?vue&type=script&lang=js"

import "./Publicidad.vue?vue&type=style&index=0&id=2fd0a3e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd0a3e6"]])

export default __exports__